<template>
  <BreadCrumbDetail :PageTitle="pageTitle" />
  <PermissionsContent />
</template>

<script lang="ts">
import { defineComponent,onMounted, inject, ref } from "vue";
import stateStore from "../../utils/store";

import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import PermissionsContent from "../../components/Settings/PermissionsAddContent.vue";
import { useRoute } from "vue-router";
import axios from 'axios';
import { Permissions } from "@/utils/Model";


export default defineComponent({
  name: "PermissionsAddPage",
  components: {
    BreadCrumbDetail,
    PermissionsContent,
  },
  setup(){
    let pageTitle  = ref('Ajouter une permission')
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");

    let permissionsShow =new Array<Permissions>();
    const backApi=inject('back');
    const route = useRoute();
    let codePermission = route.params.id;
    let token: string|null = localStorage.getItem('login_token');

    const getPermissionsId = (codePermission) =>{
        axios.get(backApi+'/secure/permissions/'+codePermission+'/show',{  
        headers: {
            Authorization: `Bearer ${token}`
        } 
        })
        .then((response) => {         
          permissionsShow = response.data;
          pageTitle.value = 'Modifier une permission | ' + response.data.name

        }).catch((error) => {
          if( error.response){
              console.log(error.response.data); // => the response payload 
          }
        });
    }
    onMounted(() => {
        if (codePermission == 'null') {
          pageTitle.value = 'Ajouter une permission';
        } else {
          getPermissionsId(codePermission)
        }

        stateStoreInstance.show = true;
    });
    return {
      pageTitle,
      stateStoreInstance
    };
  }
});
</script>